import React from "react";
import PropTypes from "prop-types";
import Image from "../image";

const MiniInfoCard = ({
  title,
  image,
  imageSourceUrl,
  extraClass = "",
  imageClass = "w-10 h-10 fill-black-lighter group-hover:fill-white dark:fill-white dark:group-hover:fill-black-lighter",
  descContainerClass = "text-sm text-white pt-2",
  textStyle = "text-gray-generic"
}) => {
  return (
    <div className={`flex ${extraClass}`}>
      {(image || imageSourceUrl) && (
        <Image
          imageAlt={title}
          image={image ?? ""}
          imageClass={imageClass}
          sourceUrl={imageSourceUrl}
        />
      )}
      <div className={descContainerClass}>
        <div
          className={textStyle}
          dangerouslySetInnerHTML={{ __html: title }}
        />
      </div>
    </div>
  );
};

MiniInfoCard.propTypes = {
  extraClass: PropTypes.string,
  imageClass: PropTypes.string,
  descContainerClass: PropTypes.string,
  textStyle: PropTypes.string
};

export default MiniInfoCard;
